'use client'

import { IconButtonProps, IconButton, styled } from '@mui/material'
import React, { memo } from 'react'
import CloseButtonIcon from '@assets/closeButtonIcon.svg'

const RoundButton = styled(IconButton)({
  backgroundColor: 'var(--dewi_colors_gray_8) !important',
  borderRadius: '50%',
  width: '40px',
  height: '40px',
})

export type CloseButtonProps = IconButtonProps

const CloseButton = ({ ...rest }: CloseButtonProps) => {
  return (
    <RoundButton {...rest}>
      <CloseButtonIcon />
    </RoundButton>
  )
}

export default memo(CloseButton)
